
/* injects from baggage-loader */

import loadTypes from 'utils/loadTypes'

import {SITES} from '../sites'
import {GET_STORAGE} from '../wizard'
import {MERCHANT, MERCHANT_CREATE} from '../merchants'
import moment from 'moment'

export const CURRENT_USER = loadTypes('CURRENT_USER')
export const LOGIN = loadTypes('LOGIN')
export const SIGNUP = loadTypes('SIGNUP')
export const ROLES = loadTypes('ROLES')
export const LOGOUT = loadTypes('LOGOUT')
export const FORGOT = loadTypes('FORGOT')
export const CURRENT_USER_EDIT_PROFILE = loadTypes('CURRENT_USER_EDIT_PROFILE')
export const CURRENT_USER_SET_PASSWORD = loadTypes('CURRENT_USER_SET_PASSWORD')
export const EXCHANGE_TRACKER_TOKEN = loadTypes('EXCHANGE_TRACKER_TOKEN')

export const CURRENT_USER_FETCH_STATUS = 'CURRENT_USER_FETCH_STATUS'
export const CURRENT_USER_LOGGING_STATUS = 'CURRENT_USER_LOGGING_STATUS'
export const CURRENT_USER_SET_TOKEN = 'CURRENT_USER_SET_TOKEN'
export const CURRENT_USER_DELETE_TOKEN = 'CURRENT_USER_DELETE_TOKEN'
export const CURRENT_USER_SET_SITE_ID = 'CURRENT_USER_SET_SITE_ID'
export const CURRENT_USER_SET_DATE_RANGE = 'CURRENT_USER_SET_DATE_RANGE'
export const CURRENT_USER_SET_TIME_PERIOD = 'CURRENT_USER_SET_TIME_PERIOD'
export const CURRENT_USER_SET_CONVERSION_TYPE =
  'CURRENT_USER_SET_CONVERSION_TYPE'
export const CURRENT_USER_SELECTED_SITES = 'CURRENT_USER_SELECTED_SITES'

const getFromLocalStorage = name => {
  // Checking embedded GET param to prevent being authorized when embeding to e-commerce platform admin
  // TODO: Find a better way
  if (/[?&]embedded=[^&]+/.test(window.location.search)) return null
  return localStorage.getItem(name)
}
const getToken = () => {
  return __ACCESS_TOKEN__ || getFromLocalStorage('token') || null
}
const getSites = () => {
  try {
    const sites = getFromLocalStorage('selectedAggregatedSites')
    if (!sites) return {}
    return JSON.parse(sites)
  } catch (err) {
    return {}
  }
}

const initialState = {
  isFetching: false,
  isCurrentUserFetching: false,
  isLogginIn: false,
  isAuthenticated: !!getToken(),
  token: getToken(),
  aggregatedSites: getSites(),
  ttl: null,
  userId: null,
  merchantId: null,
  siteId: getFromLocalStorage('siteId'),
  selectedTimePeriod: null,
  selectedStartDate: moment()
    .clone()
    .subtract(2, 'days')
    .startOf('days')
    .toDate(),
  selectedEndDate: moment().clone().subtract(1, 'days').endOf('days').toDate(),
  dynamicDateType: (__DEFAULT_START_DATE__ || __DEFAULT_START_DATE__) ? '' : 'yesterday',
  errorMessage: '',
  permissions: null,
  storage: null,
  conversionType: 'Reg finished'
}

const getCurrentUserSiteId = (state, action) => {
  const sites = action.response

  if (!sites || !sites.length) return null

  return state.siteId && sites.some(site => site.id === state.siteId)
    ? state.siteId
    : sites[0].id
}

const processSelectedSites = (state, action) => {
  const {aggregatedSites, merchantId} = state

  const newSites = {
    ...aggregatedSites,
    [merchantId]: action.sites || []
  }

  localStorage.setItem('selectedAggregatedSites', JSON.stringify(newSites))
  return newSites
}

const processRoles = (state, action) => {
  const {merchantId} = state

  if (!merchantId || !action.response) return null

  return action.response[merchantId]
}

export default function currentUser(state = initialState, action = {}) {
  switch (action.type) {
    case LOGIN.REQUEST:
      return {
        ...state,
        isFetching: true,
        isAuthenticated: false,
        errorMessage: ''
      }

    case LOGIN.SUCCESS:
      const {id: token, ttl, userId} = action.response
      return {
        ...state,
        isFetching: false,
        isAuthenticated: true,
        errorMessage: '',
        token,
        ttl,
        userId
      }

    case LOGIN.FAILURE:
      return {
        ...state,
        isFetching: false,
        isAuthenticated: false,
        errorMessage: action.message
      }

    case SIGNUP.REQUEST:
      return {
        ...state,
        isFetching: true,
        isAuthenticated: false,
        errorMessage: ''
      }

    case SIGNUP.SUCCESS:
      return {
        ...state,
        isFetching: false,
        isAuthenticated: false,
        errorMessage: '',
        userId: action.response.id
      }

    case SIGNUP.FAILURE:
      return {
        ...state,
        isFetching: false,
        isAuthenticated: false,
        errorMessage: action.message
      }

    case LOGOUT.REQUEST:
      return {
        ...state,
        isFetching: true
      }

    case LOGOUT.SUCCESS:
    case LOGOUT.FAILURE:
      return {
        ...state,
        isFetching: false,
        isAuthenticated: false,
        isCurrentUserFetching: false,
        token: null,
        ttl: null,
        userId: null,
        merchantId: null,
        siteId: null
      }

    case FORGOT.REQUEST:
      return {
        ...state,
        isFetching: true,
        errorMessage: ''
      }

    case FORGOT.SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: ''
      }

    case FORGOT.FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.message
      }

    case CURRENT_USER_SET_TOKEN:
      return {
        ...state,
        token: action.token,
        isAuthenticated: true
      }

    case CURRENT_USER_SELECTED_SITES:
      return {
        ...state,
        aggregatedSites: processSelectedSites(state, action)
      }

    case CURRENT_USER_DELETE_TOKEN:
      return {
        ...state,
        token: null,
        isAuthenticated: false
      }

    case CURRENT_USER.REQUEST:
      return {
        ...state,
        isFetching: true
      }

    case CURRENT_USER.SUCCESS:
      return {
        ...state,
        isFetching: false,
        isAuthenticated: true,
        userId: action.response.id,
        merchantId: action.response.merchantId,
        storage: action.response.storage,
        userRoles: action.response.roles
      }

    case SITES.SUCCESS:
      return {
        ...state,
        siteId: getCurrentUserSiteId(state, action)
      }

    case MERCHANT.SUCCESS:
      return {
        ...state,
        merchantId: action.response[0] && action.response[0].id
      }

    case MERCHANT_CREATE.SUCCESS:
      return {
        ...state,
        merchantId: action.response.id
      }

    case CURRENT_USER.FAILURE:
      return {
        ...state,
        isFetching: false,
        isAuthenticated: false,
        errorMessage: action.message
      }

    case CURRENT_USER_EDIT_PROFILE.REQUEST:
      return {
        ...state,
        isFetching: true
      }

    case CURRENT_USER_EDIT_PROFILE.SUCCESS:
      return {
        ...state,
        isFetching: false
      }

    case CURRENT_USER_EDIT_PROFILE.FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.message
      }

    case CURRENT_USER_SET_SITE_ID:
      return {
        ...state,
        siteId: action.siteId
      }

    case CURRENT_USER_FETCH_STATUS:
      return {
        ...state,
        isCurrentUserFetching: action.fetching
      }

    case CURRENT_USER_LOGGING_STATUS:
      return {
        ...state,
        isLogginIn: action.fetching
      }

    case CURRENT_USER_SET_DATE_RANGE:
      const newStartDate = moment(action.startDate).toDate()
      const newEndDate = moment(action.endDate).toDate()

      localStorage.setItem('startDate', moment(newStartDate).format())
      localStorage.setItem('endDate', moment(newEndDate).format())

      const periodStartRange = {
        start: newStartDate,
        end: newEndDate
      }
      const type = action.selectedTimePeriod
      const type_range =
        type == 'month' ? 'months' : type == 'year' ? 'years' : 'days'
      const dayDiff = moment(moment(newEndDate).format()).diff(
        moment(newStartDate).format(),
        type_range
      )
      const endDayStart = moment(newStartDate)
        .subtract(1 + dayDiff, type_range)
        .toDate()
      const endDayEnd = moment(newStartDate)
        .endOf('day')
        .subtract(1, type_range)
        .endOf(type_range)
        .toDate()
      const periodEndRange = {
        start: endDayStart,
        end: endDayEnd
      }
      return {
        ...state,
        selectedTimePeriodStartRange: periodStartRange,
        selectedTimePeriodEndRange: periodEndRange,
        selectedStartDate: action.startDate,
        selectedEndDate: action.endDate,
        dynamicDateType: action.dynamicDateType,
        selectedTimePeriod: action.selectedTimePeriod
      }

    case CURRENT_USER_SET_TIME_PERIOD:
      const {timePeriod, startRange, endRange, dynamicDateType} = action.data

      localStorage.setItem('startDate', moment(startRange.start).format())
      localStorage.setItem('endDate', moment(startRange.end).format())

      return {
        ...state,
        selectedTimePeriod: timePeriod,
        selectedStartDate: startRange.start,
        selectedEndDate: startRange.end,
        dynamicDateType,
        selectedTimePeriodStartRange: startRange,
        selectedTimePeriodEndRange: endRange
      }

    case CURRENT_USER_SET_CONVERSION_TYPE:
      console.log('CURRENT_USER_SET_CONVERSION_TYPE')
      const {conversionType} = action.data

      localStorage.setItem('conversionType', conversionType)

      return {
        ...state,
        conversionType
      }

    case ROLES.FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.message
      }

    case ROLES.REQUEST:
      return {
        ...state,
        isFetching: true
      }

    case ROLES.SUCCESS:
      return {
        ...state,
        isFetching: false,
        permissions: processRoles(state, action)
      }

    case GET_STORAGE.SUCCESS:
      return {
        ...state,
        storage: action.result
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/currentUser/index.js